// Material UI
import { Box, Button, Typography } from "@mui/material";

// Components
import CustomIcon from "components/CustomIcon";
import { ReportsPopOver } from "components/ReportsPopOver";
import ProText from "components/Pro/ProText";

// Ability
import { AbilityContext } from "context/Ability";
import { useAbility } from "@casl/react";

// Hooks
import useHeaderActions from "./useHeaderActions";
import { useIntl } from "react-intl";

// Styles
import headerActionsStyles from "./HeaderActions.styles";

// Enums
import icons from "enums/icons";
import { THeaderConfigProps } from "components/Management/table-config";

const HeaderActions = ({
    selectedColumns,
    isLeadershipAction,
}: {
    selectedColumns?: THeaderConfigProps[];
    isLeadershipAction?: boolean;
}): JSX.Element => {
    const classes = headerActionsStyles();
    const intl = useIntl();
    const ability = useAbility(AbilityContext);
    const showProAction = !ability.can("see", "SAAS_LD_PROJECT_BRIEF_CREATE") || ability.can("see", "LD_FREE");

    const [
        { searchDataForReport, popOverAnchor },
        { handleEditDomain, handleEditTeam, handleToggleReportMenu, handleDownloadICReport, handleGoToVcp },
    ] = useHeaderActions(selectedColumns);

    return (
        <>
            <Box className={classes.gridBtnContainer}>
                <Button className={classes.btnContainer} size="small" onClick={handleEditDomain}>
                    <Box>
                        <CustomIcon style={{ fontSize: "18px" }} icon={icons.bubbles} />
                    </Box>
                    <Typography className={classes.actionButtonLabel} component="span">
                        {intl.formatMessage({ id: "button.editParameters" })}
                    </Typography>
                </Button>

                <Button className={classes.btnContainer} size="small" onClick={handleEditTeam}>
                    <Box style={{ paddingRight: "5px" }}>
                        <CustomIcon style={{ fontSize: "18px" }} icon={icons.teamStructure} />
                    </Box>
                    <Typography className={classes.actionButtonLabel} component="span">
                        {intl.formatMessage({ id: "button.editTeam" })}
                    </Typography>
                </Button>

                {isLeadershipAction && (
                    <Button className={classes.btnContainer} size="small" onClick={handleGoToVcp}>
                        <Box style={{ paddingRight: "5px" }}>
                            <CustomIcon style={{ fontSize: "18px" }} icon={icons.book} />
                        </Box>
                        <Typography className={classes.actionButtonLabel} component="span">
                            {intl.formatMessage({ id: "button.editVcp" })}
                        </Typography>
                    </Button>
                )}

                <Button
                    className={classes.btnContainer}
                    size="small"
                    onClick={
                        isLeadershipAction
                            ? (event) => handleDownloadICReport(showProAction, event)
                            : handleToggleReportMenu
                    }
                >
                    <Box style={{ paddingRight: "5px" }}>
                        <CustomIcon style={{ fontSize: "18px" }} icon={icons.downloadFile} />
                    </Box>
                    <Typography className={classes.actionButtonLabel} component="span">
                        {intl.formatMessage({ id: "download.report" })}
                    </Typography>
                    {showProAction ? (
                        <Box className={classes.proContainer}>
                            <ProText />
                        </Box>
                    ) : null}
                </Button>

                <ReportsPopOver
                    popOverAnchor={popOverAnchor}
                    setpopOverAnchor={
                        handleToggleReportMenu || ((event) => handleDownloadICReport(showProAction, event))
                    }
                    searchData={searchDataForReport}
                    isLeadershipAction={isLeadershipAction}
                />
            </Box>
        </>
    );
};

export default HeaderActions;
